import { Input, Tooltip, Space } from "antd";
import React, { useEffect, useState } from "react";

export default function BMInput(props) {

    const { allow_update = false, placeholder = "", hide_increment = false, percent = false, number = false, min = 0, max = 0, value = "", prefix = "", prefix_width = false, select = true, width = "50px", step = 1, onChange = () => { }, disabled = false } = props;

    // if restricted to numbers and default value isn't display min
    const [v, setV] = useState((number && isNaN(parseInt(value))) ? min : value);
    const [error, setError] = useState(false);
    const [selected, setSelected] = useState(false)
    const drawError = () => {
        let ret = "";
        if (number) {
            ret = "Must be a number"
            if (min !== max) {
                ret += " between " + min.toString() + " and " + max.toString();
            }
        }
        return (ret) ? <small>{ret}</small> : "";
    }

    const validate = (_val) => {
        if (number) {
            if (_val === "") {
                return min;
            }
            // ensure input is a number
            _val = parseInt(_val);
            if (isNaN(_val) || _val !== Math.floor(_val)) {
                return min;
            }
            // in min and max are set ensure 
            if (min !== max) {
                if (_val < min || _val > max) {
                    if (_val < min) {
                        setV(min)
                        return min;
                    } else {
                        return max;
                    }
                } else {
                    return _val;
                }
            }
        } else {
            return _val;
        }

    }

    // intercept change 
    const change = (e, _view = false) => {
        setSelected(false);
        if (_view) {
            if (e.target.value != validate(e.target.value)) {
                if (!error) {
                    setError(true);
                }
            } else {
                setError(false);
            }
            e.stopPropagation();
            setV(e.target.value);
            return;
        }

        e.stopPropagation();
        setV(validate(e.target.value));
        onChange(validate(e.target.value));
        setError(false);
    }

    function inNumber(value) {
        // Check if the value is not null or undefined and is a finite number
        return value !== null && value !== undefined && !isNaN(value) && isFinite(value);
    }

    // Handle increment and decrement for arrow up/down
    const keyPress = (e) => {

        if (e.key === "Enter") {
            change(e);
            return;
        }

        if (!inNumber(v)) {
            return;
        }

        let _sv = v;

        if (number) {
            // increment by 10 if shift key is held, otherwise increment by 1
            let _inc = (e.shiftKey) ? step * 10 : step;
            if (e.key === 'ArrowUp') {
                // clamp to max
                if ((v + _inc) <= max) {

                    setV(v + _inc)
                    _sv = v + _inc;
                } else {
                    setV(max)
                    _sv = max;
                }
            }
            if (e.key === 'ArrowDown') {
                // clamp to min
                if ((v - _inc) >= min) {
                    setV(v - _inc)
                    _sv = v - _inc;
                } else {
                    setV(min)
                    _sv = min;
                }
            }
        }

        if (e.hasOwnProperty("save") && e.save) {
            onChange(validate(_sv));
        }
        

    }

    useEffect(() => {

        if(allow_update && value !== v){
            setV(value)
        }

    }, [value])

    return (
        <div style={{ "display": "flex", "alignItems": "center" }}>
            {((prefix) && <div style={{ "opacity": "0.5", "fontSize": "10px", "textAlign": "right", "margin": "0px 3px" }}>
                <div style={{ "cursor": "default", "width": (prefix_width) ? prefix_width : "inherit" }}> {prefix}</div>
            </div>)}
            <Tooltip placement="right" open={(error)} title={drawError()} >

                {(number && <div className="bm-hover">
                    <Space size={0}>
                        <Input disabled={disabled} suffix={(percent) ? "%" : ""} onKeyDown={(e) => keyPress(e)} placeholder={placeholder} onBlur={(e) => change(e)} value={v} onChange={(e) => change(e, true)} onFocus={(e) => {
                            if (select) {
                                e.target.select(e)
                                setSelected(true)
                            }
                        }} className={(error) ? "simple-input err" : "simple-input"} style={{ "width": width, "borderBottom": "1px solid #eee" }} bordered={false} />
                        <div style={{ "marginTop": "-2px", "position": "relative", "top": "-1px", "marginLeft": "-15px", "opacity": (selected || hide_increment) ? "0" : "1" }}>
                            <Space size={0} direction="vertical">
                                <div onClick={() => keyPress({ key: "ArrowUp", shiftKey: false, save: true })} className='inc-btn'>+</div>
                                <div onClick={() => keyPress({ key: "ArrowDown", shiftKey: false, save: true })} className='inc-btn'>-</div>
                            </Space>
                        </div>
                    </Space>
                </div>)}

                {(!number && <>
                    <Input disabled={disabled} onKeyDown={(e) => keyPress(e)} placeholder={placeholder} onBlur={(e) => change(e)} value={v} onChange={(e) => change(e, true)} onFocus={(e) => (select && e.target.select(e))} className={(error) ? "simple-input err" : "simple-input"} style={{ "width": width, "borderBottom": "1px solid #eee" }} bordered={false} />
                </>)}


            </Tooltip>
        </div>
    )
}